module.exports = __webpack_public_path__ + "img/em5.badc07ce.jpg";